import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Checkbox, TableBody, TableCell, TableRow } from '@material-ui/core';

import useStyles from '../useStyles';

const Body = ({ columns, rows, selectable, striped, dense }) => {
  const classes = useStyles();
  const cellClass = classnames(
    classes.cell,
    striped && classes.cellStriped,
    dense && classes.cellDense
  );

  return (
    <TableBody>
      {rows.map((row) => (
        // Striped rows keep their stripe on hover — the tint is dropped by design, not disabled by CSS.
        <TableRow
          hover={!striped}
          tabIndex={-1}
          key={row.key}
          className={classnames(classes.row, striped && classes.rowStriped)}
          selected={row.selected}
          onClick={row.onClick}
        >
          {selectable && (
            <TableCell padding="checkbox" className={cellClass}>
              <Checkbox checked={!!row.selected} inputProps={{ 'aria-label': 'select row' }} />
            </TableCell>
          )}
          {row.cells.map((cell, index) => (
            <TableCell
              key={columns[index]?.id || index}
              align={cell.align || columns[index]?.align}
              className={classnames(cellClass, cell.className)}
              onClick={cell.onClick}
            >
              {cell.content}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
};

Body.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string.isRequired })).isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      cells: PropTypes.arrayOf(
        PropTypes.shape({
          content: PropTypes.node,
          align: PropTypes.string,
          className: PropTypes.string,
          onClick: PropTypes.func,
        })
      ).isRequired,
      onClick: PropTypes.func,
      selected: PropTypes.bool,
    })
  ).isRequired,
  selectable: PropTypes.bool,
  striped: PropTypes.bool,
  dense: PropTypes.bool,
};

Body.defaultProps = {
  selectable: false,
  striped: false,
  dense: false,
};

export default Body;
